import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Input from "@mui/material/Input";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

const EditTenantModal = (props) =>{

    const {openEdit,setOpenEdit,sftpHost,sftpUserName,sftpPassword,sessionExpire,tenantId,handleEditChange,handleFileChange,handleEditClickSubmit,loading} = props;
    
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4
    };

    return (
        <Modal open={openEdit} onClose={() => setOpenEdit(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h4" component="h2">
                    Edit Tenant Data
                </Typography>
                <br></br>
                <Typography id="modal-modal-title" variant="h6" component="h6">
                    <FormControl fullWidth>
                        <TextField sx={{ mb: 1 }} id="sftpConfig.host" label="SFTP Host" value={sftpHost} onChange={handleEditChange} />
                        <br></br>
                        <TextField sx={{ mb: 1 }} id="sftpConfig.username" label="SFTP Username" value={sftpUserName} onChange={handleEditChange} />
                        <br></br>
                        <TextField sx={{ mb: 1 }} id="sftpConfig.password" label="SFTP Password" value={sftpPassword} onChange={handleEditChange} />
                        <br></br>
                        <TextField sx={{ mb: 1 }} id="sessionExpire" type="number" label="Session Expiry Time (in seconds)" value={sessionExpire} onChange={handleEditChange}  inputProps={{ min: 1 }}/>
                        <br></br>
                        Upload Logo:
                        <Input id="blobData" type="file" onChange={handleFileChange} />
                    </FormControl>
                </Typography>

                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    {loading ? <CircularProgress sx={{ color: "blue", marginLeft: "5%" }} /> :
                    <Button type="submit" variant="contained" color="primary" onClick={() => handleEditClickSubmit(tenantId)} >
                        Submit
                    </Button>}
                </Typography>
            </Box>
        </Modal>
    )
}

export default EditTenantModal;


